<p-drawer styleClass="u ui-sidebar-lg"
  [style]="{'width':'auto','max-width': '920px','height':'auto','overflow-y': 'auto','max-height':'100%'}"
  [(visible)]="finraExceptionService.showView" position="right" [baseZIndex]="10000">
  <div class="ui-grid ui-grid-responsive ui-fluid ">
    <div class="ui-grid ui-grid-responsive ui-fluid">
      <div class="ui-grid-col-12">
        @for(fieldDictionary of fieldDictionaryList; track fieldDictionary.uiFieldName + '-'+ $index) {
          <div class="ui-grid-col-6"> <span>
            <div class="ui-grid-col-4 quick-view-grid-row-hg">
              <label for="uiFieldName">{{fieldDictionary.uiFieldName}}</label>
            </div>
            <div lass="ui-grid-col-3 quick-view-grid-row-hg">
              <input [disabled]="true" pInputText [(ngModel)]="fieldDictionary.jsonValue" style="width:65%" class="finra-exp-view-input"/>
            </div>
          </span>
        </div>
        }
      </div>
  </div>
  </div>
</p-drawer>